
import React from 'react';
import { motion } from 'framer-motion';

function Intro() {
    return (
        <div className='min-h-screen bg-primary flex flex-col lg:flex-row items-center justify-center px-8 lg:px-20 gap-10 overflow-hidden'>
            <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className='w-full lg:w-1/2 flex justify-center lg:justify-end'
            >
                <div className="w-[300px] h-[300px] md:w-[550px] md:h-[550px]">
                    <dotlottie-wc
                        src="https://lottie.host/e089b9aa-7b7e-4bcb-952e-9c780990a951/endG16bXD7.lottie"
                        background="transparent"
                        speed="1"
                        style={{ width: '100%', height: '100%' }}
                        autoplay
                        loop
                    ></dotlottie-wc>
                </div>
            </motion.div>

            {/* Right Side: */}
            <motion.div 
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className='w-full lg:w-1/2 text-center lg:text-left'
            >
                <h1 className='text-5xl md:text-5xl lg:text-5xl font-bold text-white tracking-tighter leading-[1.05]'>
                    <span className='text-secondary'>Digital marketing</span> <br /> 
                    made to convert, <br />
                    not <span className='text-white italic'>confuse</span>
                </h1>
                
                <motion.div 
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1 }}
                    className="mt-8 flex flex-col md:flex-row items-center gap-6 justify-center lg:justify-start"
                >
                    <div className="h-[2px] w-20 bg-secondary hidden md:block"></div>
                    <p className="text-gray-400 text-xl font-light tracking-wide">
                        Modern strategies for ambitious brands.
                    </p>
                </motion.div>
            </motion.div>

            <div className="absolute top-0 right-0 -z-0 opacity-20">
                <div className="w-96 h-96 bg-secondary blur-[150px] rounded-full"></div>
            </div>
        </div>
    )
}

export default Intro;